import { Divider, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "../../../../utils/useStore";
import { EvalLicensedModule, EvalStore } from "../../Stores/EvalStore";

interface OwnProps {
    module?: EvalLicensedModule;
}

type Props = OwnProps;

const ModuleCardFooter: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    const store = useStore(EvalStore);
    const authStore = useStore(AuthStore);

    const moduleUIModel = store.getModuleUIModel(
        props.module?.evaluationModuleId,
    );
    let headerContent: React.ReactNode = null;

    const moduleScore = moduleUIModel?.moduleScore?.toFixed(2);

    if (
        moduleScore !== null &&
        moduleScore !== undefined &&
        authStore.canUserView("Module Scores")
    ) {
        headerContent = (
            <Typography variant={"h5"}>
                Overall {props.module?.name} Score:{" "}
                <span style={{ fontWeight: "normal" }}>{moduleScore}%</span>
            </Typography>
        );
    }

    return (
        <>
            {Boolean(headerContent) && (
                <>
                    <Divider
                        variant={"middle"}
                        style={{ marginBottom: "8px" }}
                    />
                    <Grid
                        item
                        xs={12}
                        direction={"row"}
                        wrap={"nowrap"}
                        container
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        sx={{
                            paddingLeft: 3,
                            paddingRight: 3,
                            marginTop: 3,
                            paddingBottom: 2,
                        }}
                    >
                        <Grid item xs={4}>
                            {headerContent}
                        </Grid>
                        <Grid
                            item
                            xs={8}
                            container
                            justifyContent={"flex-start"}
                            alignItems={"baseline"}
                            wrap={"wrap"}
                        ></Grid>
                    </Grid>
                </>
            )}
        </>
    );
});

export default ModuleCardFooter;
